import { render, staticRenderFns } from "./RegisterComplete.vue?vue&type=template&id=6506c278&scoped=true&"
import script from "./RegisterComplete.vue?vue&type=script&lang=js&"
export * from "./RegisterComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegisterComplete.vue?vue&type=style&index=0&id=6506c278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506c278",
  null
  
)

export default component.exports